import React from 'react';

import { useParams } from 'react-router';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { BannerFormComp, BannerListComp } from 'pages/banner/components';

export function BannerList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['BANNER_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <BannerListComp />
        </ListagemProvider>
    );
}

export function BannerForm() {
    const { hasFormPermission, alertNotPermission } = usePermissionsContext();
    const { id } = useParams();

    if (!hasFormPermission('BANNER', id)) return alertNotPermission();

    return (
        <FormProvider>
            <BannerFormComp />
        </FormProvider>
    );
}
